import React from 'react';

/**
 * BlockSubtitle — controllable subtitle rendered under a block heading.
 *
 * Renders a `<p>` (or other element via `tag`) only if `text` is a non-empty
 * string. Templates pass their own `className` so spacing, font and colour
 * inherit the local invite-block paragraph pattern.
 *
 * Props:
 *   text       — string | null | undefined. May contain HTML when `asHtml=true`.
 *   className  — full class string to apply to the rendered element.
 *   tag        — 'p' | 'div' | string. Defaults to 'p'.
 *   style      — optional inline style passthrough (templates may pass
 *                CSS custom properties or per-block margins).
 *   asHtml     — when true (default), render via dangerouslySetInnerHTML —
 *                most templates' subtitles come from a RichTextEditor in
 *                the constructor, which produces HTML. Pass false when
 *                the source is plain text and HTML escaping is required.
 *
 * Defaults are NOT carried by this component — the canonical fallback
 * copy lives in the admin defaults (`server/routes/admin.js`), which is
 * deep-merged into every project's `block_content` server-side. Keeping
 * the component pure means adding a new template never duplicates copy.
 */
export default function BlockSubtitle({
  text,
  className = '',
  tag: Tag = 'p',
  style,
  asHtml = true,
}) {
  if (!text || !String(text).trim()) return null;
  if (asHtml) {
    return (
      <Tag
        className={className}
        style={style}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }
  return (
    <Tag className={className} style={style}>{text}</Tag>
  );
}
